var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skill"},[_c('p',{staticClass:"skill__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('k-progress',{class:_vm.classname,attrs:{"percent":_vm.value,"show-text":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }